import React, { useRef } from 'react';
import { map } from 'lodash';

const CSVSampleDownload = ({ fields, linkTitle, linkClass }) => {
    const linkRef = useRef(null);

    // Helper function to safely escape CSV fields
    const escapeCSVField = (val) => {
        if (val === null || val === undefined) return '';
        
        let stringValue = String(val);
        
        // If the value contains quotes, commas, or newlines, it must be escaped
        if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('\r')) {
            // Double up any existing double quotes, then wrap the whole thing in quotes
            stringValue = `"${stringValue.replace(/"/g, '""')}"`;
        }
        
        return stringValue;
    };

    const downloadCSV = () => {
        const keys = map(fields, 'key').map(escapeCSVField);
        const placeholders = map(fields, 'tooltip').map(escapeCSVField);
        
        const csvContent = keys.join(',') + '\r\n' + placeholders.join(',');
        const fileData = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        
        // Clean up old object URLs to prevent memory leaks
        if (linkRef.current.href) {
            URL.revokeObjectURL(linkRef.current.href);
        }

        linkRef.current.href = URL.createObjectURL(fileData);
    };

    return (
        <a 
            ref={linkRef} 
            onClick={downloadCSV} 
            className={linkClass} 
            download='template.csv'
        >
            {linkTitle}
        </a>
    );
};

export default CSVSampleDownload;